import { useQuery } from "@tanstack/react-query";
import { useAccessToken, useTenantData } from "@/hooks";
import { PaymentApi } from "@/openapi/generated";
import type { ScrollPaymentsQuery } from "@/openapi/generated/models";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface UsePaymentsScrollGetParams {
  scrollPaymentsQuery: ScrollPaymentsQuery;
  page?: number;
  pageSize?: number;
  lastSelectedId?: number;
  active?: boolean;
  enabled?: boolean;
}

export const usePaymentsScrollGet = ({
  scrollPaymentsQuery,
  page = 1,
  pageSize = 50,
  lastSelectedId,
  active,
  enabled = true,
}: UsePaymentsScrollGetParams) => {
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();

  return useQuery({
    queryKey: [
      QueryKeys.Payments,
      "scroll",
      scrollPaymentsQuery,
      page,
      pageSize,
      lastSelectedId,
      active,
    ],
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(PaymentApi, accessToken);
      return service.apiPaymentsScrollPost({
        scrollPaymentsQuery,
        page,
        pageSize,
        lastSelectedId,
        active,
        xTenantID: tenantId,
      });
    },
    enabled: !!accessToken && !!tenantId && enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
